import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "block", "template", "type", "up", "down"]

  connect() {
    this.nextIndex = Date.now()
    this.reindex()
  }

  add() {
    const template = this.templateTargets.find(element => element.dataset.blockType === this.typeTarget.value)
    const html = template.innerHTML.replaceAll("__BLOCK_INDEX__", `new-${this.nextIndex++}`)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.reindex()
    this.blockTargets[this.blockTargets.length - 1].querySelector("input:not([type=hidden]), textarea")?.focus()
  }

  remove(event) {
    event.currentTarget.closest("[data-academy-blocks-target=block]").remove()
    this.reindex()
  }

  moveUp(event) {
    const block = event.currentTarget.closest("[data-academy-blocks-target=block]")
    if (block.previousElementSibling) this.containerTarget.insertBefore(block, block.previousElementSibling)
    this.reindex()
  }

  moveDown(event) {
    const block = event.currentTarget.closest("[data-academy-blocks-target=block]")
    if (block.nextElementSibling) this.containerTarget.insertBefore(block.nextElementSibling, block)
    this.reindex()
  }

  reindex() {
    this.blockTargets.forEach((block, index) => {
      block.querySelectorAll("[name]").forEach(field => {
        field.name = field.name.replace(/\[blocks\]\[[^\]]+\]/, `[blocks][${index}]`)
      })
      block.querySelector("[data-academy-blocks-target=up]").disabled = index === 0
      block.querySelector("[data-academy-blocks-target=down]").disabled = index === this.blockTargets.length - 1
    })
  }
}
